"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListEditor = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const theme_1 = require("../../../../theme");
const react_1 = require("react");
const common_styled_components_1 = require("../../../common-styled-components");
const TextInput_1 = require("../../../generic/TextInput");
const EngineEditor_1 = require("./EngineEditor");
const lodash_1 = require("lodash");
const FuelEditor_1 = require("./FuelEditor");
const POSNoteSearch_1 = require("../TransactionAttachments/POSNoteSearch");
const List = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${theme_1.theme.spacing(0)};
  margin-top: ${theme_1.theme.spacing(3)};
  width: 100%;
`;
const ItemColumn = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${theme_1.theme.spacing(1)};
  width: 100%;
`;
const ListEditor = ({ title, initialValues = [], addDefault, editorType, metadata, onChange, }) => {
    const [values, setValues] = (0, react_1.useState)(initialValues);
    (0, react_1.useEffect)(() => {
        setValues(initialValues);
    }, [initialValues]);
    (0, react_1.useEffect)(() => {
        if (!(0, lodash_1.isEqual)(values, initialValues)) {
            onChange(values);
        }
    }, [initialValues, onChange, values]);
    const editValue = (0, react_1.useCallback)((newValue, index) => {
        setValues((prevValues) => {
            const updatedValues = [...prevValues];
            updatedValues[index] = newValue;
            return updatedValues;
        });
    }, []);
    const remove = (0, react_1.useCallback)((index) => {
        setValues((prevValues) => {
            const updatedValues = prevValues.filter((_v, i) => i !== index);
            return updatedValues;
        });
    }, [values]);
    return ((0, jsx_runtime_1.jsxs)(List, { children: [title && (0, jsx_runtime_1.jsx)(common_styled_components_1.SmallSubtitle, { children: title }), values.map((v, index) => {
                if (editorType === "string" && typeof v === "string") {
                    return ((0, jsx_runtime_1.jsxs)(common_styled_components_1.SeparatedRow, { children: [(0, jsx_runtime_1.jsx)(TextInput_1.TextInput, { value: v, onChange: (newValue) => editValue(newValue, index) }, index), (0, jsx_runtime_1.jsx)(common_styled_components_1.SecondaryButton, { type: "button", onClick: () => remove(index), children: "-" })] }));
                }
                else if (editorType === "ShipEngineType" && typeof v === "object") {
                    return ((0, jsx_runtime_1.jsx)(EngineEditor_1.EngineEditor, { metadata: metadata, index: index, updateEngine: (i, engine) => editValue(engine, i), initialValue: v, remove: remove }, index));
                }
                else if (editorType === "FuelAmount" && typeof v === "object") {
                    return ((0, jsx_runtime_1.jsx)(FuelEditor_1.FuelEditor, { metadata: metadata, index: index, updateFuelAmount: (i, fuelAmount) => editValue(fuelAmount, i), initialValue: v, remove: remove }, index));
                }
                else if (editorType === "POSNote" && typeof v === "object") {
                    return ((0, jsx_runtime_1.jsx)(ItemColumn, { children: (0, jsx_runtime_1.jsxs)(common_styled_components_1.SeparatedRow, { children: [(0, jsx_runtime_1.jsx)(POSNoteSearch_1.POSNoteSearch, { selectedPOSData: v.id > 0
                                        ? v
                                        : undefined, selectedPOSId: v.id > 0
                                        ? v.id
                                        : undefined, onChange: (posNote) => {
                                        if (posNote) {
                                            editValue(posNote, index);
                                        }
                                    } }), (0, jsx_runtime_1.jsx)(common_styled_components_1.SecondaryButton, { type: "button", onClick: () => remove(index), children: (0, jsx_runtime_1.jsx)("span", { style: { fontSize: "2rem" }, children: "-" }) })] }) }, index));
                }
                return null;
            }), (0, jsx_runtime_1.jsx)(common_styled_components_1.SecondaryButton, { type: "button", onClick: () => setValues([...values, addDefault]), children: "+ Add" })] }));
};
exports.ListEditor = ListEditor;
